module.exports = __webpack_public_path__ + "static/dexter-8572cf6bd6adaac1c51dd2585bf96720.jpg";